const GridCardChipsData = [
  {
    id: "sale",
    label: "Sale",
    icon: "property/sale",
  },
  {
    id: "residential",
    label: "Residential",
    icon: "property/residential",
  },
  {
    id: "apartment",
    label: "Apartment",
    icon: "property/apartment",
  },
  {
    id: "ready_to_move",
    label: "Ready to Move",
    icon: "property/readytomove",
  },
  {
    id: "nri",
    label: "NRI",
    icon: "property/nri",
  },
  {
    id: "featured",
    label: "Featured",
    icon: "property/featured",
  },
];

export default GridCardChipsData;
